module.exports = __webpack_public_path__ + "img/img (15).97913a1e.jpg";